import { CognitoUserPool, CognitoUserAttribute, CognitoUser } from 'amazon-cognito-identity-js';

//TODO MOVE TO ENV
const poolData = {
    'UserPoolId': "us-east-2_QPX7KciKD",
    'ClientId': "6ol5tcb288cfhcpn9p5hn9qpau"
}

export default new CognitoUserPool(poolData);